import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function NewImagesGrid({ saving, imgPreviews, onRemoveNew }) {
  if (!imgPreviews?.length) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="caption" color="text.secondary">
        New images (will be uploaded)
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
        {imgPreviews.map((p, idx) => (
          <Box
            key={`${p.file.name}-${p.file.size}-${idx}`}
            sx={{
              position: 'relative',
              width: 64,
              height: 64,
              borderRadius: 1,
              overflow: 'hidden',
              border: '1px solid #e0e0e0',
            }}
          >
            <img
              src={p.url}
              alt={p.file.name}
              width={64}
              height={64}
              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
            />

            <Tooltip title="Remove">
              <IconButton
                size="small"
                onClick={() => onRemoveNew(idx)}
                disabled={saving}
                sx={{
                  position: 'absolute',
                  top: -8,
                  right: -8,
                  bgcolor: 'white',
                  border: '1px solid #ddd',
                  '&:hover': { bgcolor: '#f5f5f5' },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        ))}
      </Box>
    </Box>
  );
}